import React from "react";
import useRouter from "src/core/common/hooks/useRouter";
import routes from "../../routes";
import shouldRenderPage from "src/core/common/path";
import useAgeGate from "src/core/user/hooks/useAgeGate";

function Route({path, Component, componentProps}) {
  const {asPath} = useRouter();
  const [hasAllowedAge] = useAgeGate();

  const isModal = routes.isModal(path);
  const renderPage = shouldRenderPage(asPath, path);

  if (isModal && hasAllowedAge) {
    return renderPage ? <Component isOpen={renderPage} {...componentProps} /> : null;
  }

  return renderPage ? <Component {...componentProps} /> : null;
}

export default Route;
